import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=0b08fa64"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"
import style0 from "./Goals.vue?vue&type=style&index=0&id=0b08fa64&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b08fa64')) {
      api.createRecord('0b08fa64', component.options)
    } else {
      api.reload('0b08fa64', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=0b08fa64", function () {
      api.rerender('0b08fa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/followed/Goals.vue"
export default component.exports